import React from 'react';

const HowItWorksItem = ({ icon, title, description }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-3">
      <article className="card">
        <div className="center">
          <div className="mb-2">
            <img src={`img/sicknote/how/icon-${icon}.png`} alt={title} style={{ width: '50px', height: '50px' }} />
          </div>
          <h4 className="mb-2 keywords">{title}</h4>
          <p>{description}</p>
        </div>
      </article>
    </div>
  );
};

export default HowItWorksItem;
